import { render, staticRenderFns } from "./acceptRejectUpdateDialog.vue?vue&type=template&id=6eb4c60f&"
import script from "./acceptRejectUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./acceptRejectUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports